<template>
  <v-container fluid>
    <h1>
      Folders
    </h1>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  metaInfo() {
    this.$store.commit('setTitle', 'Folders');
    return {
      title: this.$store.getters.title,
    }
  },
  computed: {
    ...mapGetters([
      'folders',
    ])
  }
}
</script>
